import { Controller } from "@hotwired/stimulus"
import { ensureDatepicker } from "../lib/datepicker_loader"

// Выбор даты (дня) через bootstrap-datepicker.
//
// Структура разметки (см. DatePickerInput / date_picker_field_tag):
//   - target "display" — видимый text input в формате dd.mm.yyyy (без name,
//     на сервер НЕ отправляется), им управляет datepicker;
//   - target "value"   — скрытый input с реальным значением в ISO (yyyy-mm-dd),
//     именно он уходит на сервер. ISO парсится Rails однозначно, что исключает
//     неоднозначность дня/месяца и не зависит от локали отображения.
//
// jQuery и плагин грузятся лениво (общий загрузчик lib/datepicker_loader).
export default class extends Controller {
  static targets = ["display", "value"]

  async connect() {
    const $ = await ensureDatepicker()
    if (!this.element.isConnected) return // отключился, пока грузили

    this.$display = $(this.displayTarget)
    this.$display
      .datepicker({
        format: "dd.mm.yyyy",
        autoclose: true,
        todayHighlight: true,
        todayBtn: "linked",
        clearBtn: true,
        language: "ru",
        weekStart: 1,
        orientation: "bottom auto"
      })
      .on("changeDate", (e) => this.sync(e.date))
      .on("clearDate", () => this.clear())
  }

  disconnect() {
    if (this.$display && this.$display.data("datepicker")) {
      this.$display.datepicker("destroy")
    }
  }

  // Открыть календарь по клику на иконку.
  // preventDefault — фокус не уходит на иконку.
  // stopPropagation — ключевое: show() навешивает на document обработчик
  // mousedown.datepicker, который закрывает пикер при клике снаружи. Если не
  // остановить всплытие, текущий mousedown долетит до document, свежий
  // обработчик увидит цель = иконку (вне пикера) и сразу закроет календарь.
  open(event) {
    event.preventDefault()
    event.stopPropagation()
    if (this.$display) this.$display.datepicker("show")
  }

  // Записать выбранную дату в скрытое поле в ISO-формате (yyyy-mm-dd).
  sync(date) {
    if (!this.hasValueTarget) return
    this.valueTarget.value = date ? toISO(date) : ""
    this.valueTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  clear() {
    if (!this.hasValueTarget) return
    this.valueTarget.value = ""
    this.valueTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}

// Локальная дата → "yyyy-mm-dd" без сдвига часового пояса (toISOString даёт UTC
// и может «уехать» на день назад).
function toISO(date) {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, "0")
  const d = String(date.getDate()).padStart(2, "0")
  return `${y}-${m}-${d}`
}
